export class FormatNullValueAsFilter {
    public static $name = 'nullValAs';

    public static Factory() {
        return function (value: any, as: string) {
            // 0 should display as 0, not 'as'
            return value == null || typeof value === 'undefined' ? as : value;
        };
    }
}
